import React from 'react';
import { Bx, Btn, Typo, CheckboxControl, Link } from '@curry-group/mui-curcuma';
import { Grid } from '@material-ui/core';
import { validateNotEmpty, validateUrl } from '../../../helper/validator';
import { FormInput } from '../controls/input';
import { FormRTE } from '../controls/rte';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faShare } from '@fortawesome/pro-light-svg-icons';

interface IFormSharepoint {
  formData: any;
  headline?: string;
  subtitle?: string;
  subtitleComponent?: React.ReactChild;
  isEdit?: boolean;
  onChange: (formField: string, formValue: any, formName?: string) => void;
  deactivateSharepoint?: () => void;
}

export const FormSharepoint: React.FC<IFormSharepoint> = ({
  formData,
  headline,
  subtitle,
  subtitleComponent,
  isEdit = false,
  onChange,
  deactivateSharepoint
}) => {
  const [inputVal, setInputVal] = React.useState({
    termsAccepted: formData?.itemData?.termsAccepted,
  });

  const active = formData?.itemData?.sharepointActive;

  return (
    <React.Fragment>
      {headline && (
        <Bx mb={1}>
          <Typo variant="h1" component="h1">
            {headline}
          </Typo>
        </Bx>
      )}
      {subtitle && <Typo variant="subtitle1">{subtitle}</Typo>}
      {!!subtitleComponent && subtitleComponent}
      <Bx mt={4}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={6}>
                <FormInput
                  value={formData?.itemData?.title}
                  label={'Titel des Sharepoints'}
                  placeholder={'Titel eingeben'}
                  minLength={5}
                  maxLength={120}
                  onChange={val => {
                    onChange('title', val);
                  }}
                  validator={validateNotEmpty}
                  successMessage=""
                  fieldGroup={'sharepoint'}
                  lazy
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <FormInput
                  value={formData?.itemData?.url}
                  label={'URL des Sharepoints'}
                  placeholder={'URL eingeben'}
                  minLength={5}
                  onChange={val => {
                    onChange('url', val);
                  }}
                  validator={validateUrl}
                  successMessage=""
                  fieldGroup={'sharepoint'}
                  lazy
                />
              </Grid>
              {isEdit && <Grid item xs={12}>
                <Bx my={2} display="flex" flexDirection="column" justifyContent="flex-end">
                  <Btn
                    onClick={() => {
                      deactivateSharepoint?.();
                    }}
                    startIcon={active ? <FontAwesomeIcon icon={faBan} /> : <FontAwesomeIcon icon={faShare} />}
                    color={active ? "error" : "secondary"}
                    variant="contained"
                    size="large"
                  >
                    {active ? 'Sharepoint deaktivieren' : 'Sharepoint aktivieren'}
                  </Btn>
                </Bx>
              </Grid>}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Bx>
              <Typo variant="subtitle1">
                Ihre E-Mail-Adresse wird allen Mitgliedern der Community sichtbar gemacht,
                um eine direkte Kommunikation zwischen Ihnen und anderen Plattform-Mitgliedern zu ermöglichen. 
                Die Verarbeitung erfolgt auf Basis Ihrer Einwilligung, welche Sie jederzeit mit Wirkung für die Zukunft widerrufen können. 
                Dies ist möglich indem Sie den geteilten Sharepoint entfernen oder sich an <a href="mailto:info@medteconline.de">info@medteconline.de</a> wenden. 
                Im Übrigen stehen Ihnen Ihre Betroffenenrechte gem. unserer{' '}
                <Link to="/content/page/datenschutz" target="_blank" rel="noopener noreferrer">
                  Datenschutzerklärung
                </Link>{' '}zu.
              </Typo>
            </Bx>
            <Bx mt={2} pl={1}>
              <CheckboxControl
                control={{
                  color: 'primary',
                  name: 'termsAccepted',
                  value: inputVal.termsAccepted,
                  onChange: e => {
                    setInputVal({ ...inputVal, [e.target.name]: e.target.checked });
                    onChange('termsAccepted', e.target.checked);
                  },
                  style: {border: '1px solid black', borderRadius:'4px', padding:'0'},
                  disabled: isEdit
                }}
                style={{background:'white',padding:'15px 15px 15px 15px',borderRadius:'10px 10px 10px 10px',border:1,borderStyle:'solid',borderColor:'#D6D7D9'}}
                checked={inputVal.termsAccepted}
                label={
                  <Typo variant={'subtitle1'}>
                    <b>Ich willige ein</b>, dass meine E-Mail-Adresse 
                    allen Community-Mitgliedern sichtbar gemacht wird, um eine direkte Kommunikation zu ermöglichen.
                  </Typo>
                }
              />
            </Bx>
          </Grid>
          <Grid item xs={12}>
            <Bx mt={2} mb={2}>
              <FormRTE
                value={formData?.itemData?.description}
                label={'Kurzbeschreibung/Agenda'}
                placeholder={'Inhalte, die Sie in Ihrem Meeting besprechen wollen...'}
                mandatory={false}
                minLength={0}
                maxLength={2500}
                onChange={val => {
                  onChange('description', val);
                }}
                lazy
              />
            </Bx>
          </Grid>
        </Grid>
      </Bx>
    </React.Fragment>
  );
};
